import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { track } from "@/lib/analytics";
import { BUSINESS } from "@/data/business";
import { Logo } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Field, TextInput, TextArea } from "@/components/register/Fields";

const blank = { name: "", email: "", phone: "", message: "", website: "" };

export default function Contact() {
  const [f, setF] = useState(blank);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    api.post("/contact", f).then(() => { track("generate_lead", { form: "contact" }); setSent(true); setF(blank); }).catch((x) => toast.error(errMsg(x)));
  };
  return (
    <div data-testid="contact-page">
      <div className="min-h-screen max-w-5xl mx-auto px-5 sm:px-8 py-16">
        <Link to="/" className="flex items-center gap-3" data-testid="contact-home-link"><Logo /><span className="text-sm text-slate-400">Back to home</span></Link>
        <p className="eyebrow mt-16">Elite Performance Lab</p>
        <h1 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-6xl">Contact us</h1>
        <div className="mt-12 grid md:grid-cols-2 gap-10">
          <div className="space-y-5 text-slate-300" data-testid="contact-details">
            <p className="font-display font-bold text-xl text-white">{BUSINESS.name}</p>
            <p className="flex gap-3"><MapPin size={18} className="accent-text shrink-0" />{BUSINESS.address}</p>
            <p className="flex gap-3"><Mail size={18} className="accent-text shrink-0" /><a href={`mailto:${BUSINESS.email}`} className="hover:text-white break-all" data-testid="contact-email-link">{BUSINESS.email}</a></p>
            <p className="flex gap-3"><Phone size={18} className="accent-text shrink-0" /><a href={BUSINESS.phoneHref} className="hover:text-white" data-testid="contact-phone-link">{BUSINESS.phone}</a></p>
            <p className="text-sm text-slate-500">Programme venue: PropAint 'n Panel Oval, Birdwood Terrace, North Plympton SA 5037.</p>
          </div>
          {sent ? (
            <div data-testid="contact-sent" className="rounded-3xl border border-[var(--accent)]/30 bg-[var(--accent)]/[0.05] p-8">
              <p className="font-display font-bold text-2xl">Thanks — message received</p>
              <p className="mt-2 text-slate-400">We'll get back to you as soon as possible.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <Field label="Your name"><TextInput testid="contact-name" required value={f.name} onChange={set("name")} /></Field>
              <Field label="Email"><TextInput testid="contact-email" type="email" required value={f.email} onChange={set("email")} /></Field>
              <Field label="Phone (optional)"><TextInput testid="contact-phone" value={f.phone} onChange={set("phone")} /></Field>
              <Field label="Message"><TextArea testid="contact-message" rows={5} required value={f.message} onChange={set("message")} /></Field>
              <input tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={set("website")} aria-hidden="true" />
              <p className="text-xs text-slate-500">Please don't include medical information in this form.</p>
              <button data-testid="contact-submit" className="btn-primary w-full">Send message</button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
